import { useTranslation, Trans } from "next-i18next";
import ProductHeroSection from "../../components/v2/common/product-hero";
import FeaturesMonitoring from "../../components/v2/tabs/features-monitoring";
import Link from "next/link";
import PlatformFeaturesOverview from "../../components/v2/platform-features-overview";
import { IntegrationPlatform, InfraPlatform, APMPlatform, AlertsPlatform } from "../../components/v2/icons";
import CallToActionDocsLink from "../../components/v2/blog/call-to-action-docs-link";
import '../../styles/scss/_blog-section-k8s-monitoring.module.scss';

export default function AIDashboard() {
    const { t } = useTranslation("common");
    const featuresData = t("platform.dashboard.features.detailedFeatures", { returnObjects: true }) as any[];
    const features = Array.isArray(featuresData) ? featuresData : [];
    const resourcesData = t("platform.dashboard.resources.items", { returnObjects: true }) as any[];
    const resource = Array.isArray(resourcesData) ? resourcesData : [];
    const overviewData = t("platform.dashboard.overview", { returnObjects: true }) as any;
    const platformFeaturesConfig = {
        heading: overviewData?.heading,
        description: overviewData?.description,
        worksWellWithTag: overviewData?.worksWellWithTag,
        platforms: [
            {
                title: overviewData?.platforms?.[0]?.title,
                link: "https://docs.middleware.io/apm-configuration/apm_overview",
                Icon: APMPlatform,
            },
            {
                title: overviewData?.platforms?.[1]?.title,
                link: "https://docs.middleware.io/workflow/infrastructure-monitoring/container-monitoring",
                Icon: InfraPlatform,
            },
            {
                title: overviewData?.platforms?.[2]?.title,
                link: "https://docs.middleware.io/workflow/alerting/setup-alert",
                Icon: AlertsPlatform,
            },
            {
                title: overviewData?.platforms?.[3]?.title,
                link: "https://docs.middleware.io/integrations/integrations_overview",
                Icon: IntegrationPlatform,
            }
        ],
        cta: {
            text: overviewData?.cta?.text,
            link: "https://docs.middleware.io/workflow/dashboard-builder/build-dashboard-with-ai",
        },
    };


    return (
        <>

            <ProductHeroSection title={<h1><Trans i18nKey="platform.dashboard.hero.title" components={{ highlight: <span className="text-gradient" /> }} /></h1>}
                description={t("platform.dashboard.hero.description")}
                img={"/images/platform/ai-dashboard.webp"} imgMobile={"/images/platform/ai-dashboard-mobile.webp"} imgAlt={t("platform.dashboard.hero.imageAlt")} preloadImg
                hasActions={true} tips="" hasActionsDemo={true} />

            <PlatformFeaturesOverview data={platformFeaturesConfig} />

            <FeaturesMonitoring productFeatures={features}
                title={<h2><Trans i18nKey="platform.dashboard.features.title" components={{ highlight: <span className={"text-gradient"} /> }} /></h2>} tourId={""} className="ai-dashboard-features-platform" isTryOut />

            <CallToActionDocsLink
                title={t("platform.dashboard.ctaTitle")}
                docsLink="https://docs.middleware.io/workflow/dashboard-builder/build-dashboard-with-ai"
            />

            <div className="blog-section-k8s-monitoring-resources">
                <div className="container all-blogs-v2">
                    <h2>{t("platform.dashboard.resources.title")}</h2>
                    <div className="d-flex">
                        {resource.map((item, index) => (
                            <div className="inner-block" key={index}>
                                <Link href={item.link} itemProp="url">
                                    <div className="image-wrapper">
                                        <img
                                            src={item.img}
                                            alt={item.title}
                                        />
                                    </div>
                                </Link>

                                <div>
                                    <Link href={`/blog/category/${item.category}`}>
                                        <div className="category">
                                            {item.categoryLabel}
                                        </div>
                                    </Link>

                                    <div>
                                        <Link href={item.link} itemProp="url">
                                            <h4>{item.title}</h4>
                                        </Link>

                                        <div className="date-time">
                                            {item.date}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>

                </div>
            </div>

        </>
    )
}